import React from "react";

const DEFAULT_BREAKPOINTS = [100, 500, 1500];

export function bucketize(value, breakpoints) {
  if (value === null || value === undefined) return null;
  for (let i = 0; i < breakpoints.length; i++) {
    if (value < breakpoints[i]) return i;
  }
  return breakpoints.length;
}

export function PotencyCell({ value, lowerBetter = true, breakpoints }) {
  const bps = breakpoints && breakpoints.length === 3 ? breakpoints : DEFAULT_BREAKPOINTS;
  const raw = bucketize(value, bps);
  const bucket = raw === null ? null : (lowerBetter ? raw : (3 - raw));
  const cls = bucket === null ? "potency-cell--na" : `potency-cell--b${bucket}`;
  const display = value === null || value === undefined ? "—" : String(value);
  return (
    <span className={`potency-cell ${cls}`}>{display}</span>
  );
}
